// Canonical Bayer ordered-dither matrices. Shared by both the wrapper's
// `<Dither>` shaders and the `<DitheredWaves>` background shader.
export const BAYER8 = /* glsl */ `
const float BAYER[64] = float[64](
   0.0/64.0, 48.0/64.0, 12.0/64.0, 60.0/64.0,  3.0/64.0, 51.0/64.0, 15.0/64.0, 63.0/64.0,
  32.0/64.0, 16.0/64.0, 44.0/64.0, 28.0/64.0, 35.0/64.0, 19.0/64.0, 47.0/64.0, 31.0/64.0,
   8.0/64.0, 56.0/64.0,  4.0/64.0, 52.0/64.0, 11.0/64.0, 59.0/64.0,  7.0/64.0, 55.0/64.0,
  40.0/64.0, 24.0/64.0, 36.0/64.0, 20.0/64.0, 43.0/64.0, 27.0/64.0, 39.0/64.0, 23.0/64.0,
   2.0/64.0, 50.0/64.0, 14.0/64.0, 62.0/64.0,  1.0/64.0, 49.0/64.0, 13.0/64.0, 61.0/64.0,
  34.0/64.0, 18.0/64.0, 46.0/64.0, 30.0/64.0, 33.0/64.0, 17.0/64.0, 45.0/64.0, 29.0/64.0,
  10.0/64.0, 58.0/64.0,  6.0/64.0, 54.0/64.0,  9.0/64.0, 57.0/64.0,  5.0/64.0, 53.0/64.0,
  42.0/64.0, 26.0/64.0, 38.0/64.0, 22.0/64.0, 41.0/64.0, 25.0/64.0, 37.0/64.0, 21.0/64.0
);
float bayer8(vec2 p){
  int x = int(mod(p.x, 8.0));
  int y = int(mod(p.y, 8.0));
  return BAYER[y * 8 + x] - 0.5;
}
float bayer2(vec2 p){
  int x = int(mod(p.x, 2.0));
  int y = int(mod(p.y, 2.0));
  float m[4] = float[4](0.0/4.0, 2.0/4.0, 3.0/4.0, 1.0/4.0);
  return m[y * 2 + x] - 0.5;
}
float bayer4(vec2 p){
  int x = int(mod(p.x, 4.0));
  int y = int(mod(p.y, 4.0));
  float m[16] = float[16](
     0.0/16.0,  8.0/16.0,  2.0/16.0, 10.0/16.0,
    12.0/16.0,  4.0/16.0, 14.0/16.0,  6.0/16.0,
     3.0/16.0, 11.0/16.0,  1.0/16.0,  9.0/16.0,
    15.0/16.0,  7.0/16.0, 13.0/16.0,  5.0/16.0
  );
  return m[y * 4 + x] - 0.5;
}
float bayerN(vec2 p, float n){
  if (n < 3.0) return bayer2(p);
  if (n < 5.0) return bayer4(p);
  return bayer8(p);
}
`;
